import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useStands } from '../context/StandsContext';
import StandGalleryView from './StandGalleryView';
import StandTableView from './StandTableView';
import { computeStandMetrics } from '../utils/standMetrics';
import { useTheme } from '../context/ThemeContext';

// Simple page to reuse existing listing components with a filter coming from the URL.
// Supported filters: total | available | reserved | maintenance | low-stock

const FilteredStandsPage: React.FC = () => {
  const { filter } = useParams();
  const { stands, publications, availablePosters, getLowStockPublications } = useStands();
  const { userPreferences } = useTheme();

  const normalized = (filter || '').toLowerCase();

  const applyFilter = () => {
    // Intervalle préventif par défaut (3 mois) éventuellement provenant de settings plus tard
    const intervalMonths = 3;
    switch (normalized) {
      case 'available':
        // Afficher simplement les stands non réservés.
        // La contrainte "pas de maintenance due" était trop stricte et masquait des présents réellement disponibles.
        return stands.filter(s => !s.isReserved);
      case 'reserved':
        return stands.filter(s => computeStandMetrics(s, publications, intervalMonths).isReserved);
      case 'maintenance':
        return stands.filter(s => computeStandMetrics(s, publications, intervalMonths).maintenance.needed);
      case 'low-stock':
        return stands.filter(s => computeStandMetrics(s, publications, intervalMonths).lowStockCount > 0);
      case 'total':
      default:
        return stands;
    }
  };

  const filtered = applyFilter();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          Présentoirs – {normalized || 'total'} ({filtered.length})
        </h1>
        <Link to="/" className="btn btn-secondary">Retour tableau de bord</Link>
      </div>

      {userPreferences.viewMode === 'table' ? (
        <StandTableView
          stands={filtered}
          publications={publications}
          availablePosters={availablePosters}
          onPosterRequest={() => {}}
          onUpdateStock={() => {}}
          getLowStockPublications={getLowStockPublications}
        />
      ) : (
        <StandGalleryView
          stands={filtered}
          publications={publications}
          availablePosters={availablePosters}
          onPosterRequest={() => {}}
          onUpdateStock={() => {}}
          getLowStockPublications={getLowStockPublications}
          onSelectAction={() => {}}
        />
      )}
    </div>
  );
};

export default FilteredStandsPage;
